/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCommentAltLines} from '@fortawesome/pro-duotone-svg-icons';

const ReportCardCommentsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCommentAltLines} {...props} />
);

export default ReportCardCommentsIcon;
